export const courierNameToCode: Record<string, string> = {
    CJ대한통운: "kr.cjlogistics",
    롯데택배: "kr.lotte",
    로젠택배: "kr.logen",
    우체국택배: "kr.epost",
    경동택배: "kr.kdexp",
};
